import React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import { PublicClientApplication } from '@azure/msal-browser';
import { getConfig } from './config';

import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/App/App';

// Start the mocking conditionally.
// THIS SEEMS TO INTERFERE WITH DEBUGGER SO TURN ON WHEN NEEDED
if (process.env.NODE_ENV === 'development') {
  // const { worker } = require('./mocks/browser');
  // console.log('worker', worker);
  // worker.start();
}
export const msalInstance = new PublicClientApplication(getConfig().msalConfig);
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App pca={msalInstance} />
  </React.StrictMode>
);
// ReactDOM.render(
//   <React.StrictMode>
//     <App pca={msalInstance} />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
